import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../main-page.service';
import { Http } from '@angular/http';
import { ConnectorGridComponent } from '../master-data/connectors/connector-grid/connector-grid.component';


@Component({
  selector: 'app-side-menu',
  template: `<div class="sidemenu-panel" id="sidebar">
    <div class="sidebarSystem pleft-20">
        <select name="" id="droplist">
            <option value="" disabled selected>SYSTEM NAME</option>
            <option value="1">MT</option>
            <option value="2">MI</option>
            <option value="3">MQ</option>
        </select>
    </div>
    <div class="sidemenu-tabs-wrapper">
        <div>
            <h5 class="nav-header pleft-20">
                <i class="fa fa-th"></i> Master data</h5>
            <div [class.activeMenuItem]="choiceName === 'crossSections'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('crossSections','masterData')">
                Cross sections
            </div>
            <div [class.activeMenuItem]="choiceName === 'connectors'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('connectors','masterData')">
                Connectors
            </div>
            <div [class.activeMenuItem]="choiceName === 'bases'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('bases','masterData')">
                Bases
            </div>
            <div [class.activeMenuItem]="choiceName === 'pipeFastenings'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipeFastenings','masterData')">
                Pipe fastenings
            </div>
            <div [class.activeMenuItem]="choiceName === 'accesories'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('accesories','masterData')">
                Accesories
            </div>
            <div [class.activeMenuItem]="choiceName === 'pipeRings'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipeRings','masterData')">
                Pipe rings
            </div>
            <div [class.activeMenuItem]="choiceName === 'channels'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('channels','masterData')">
                Channels
            </div>
            <div [class.activeMenuItem]="choiceName === 'pipes'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipes','masterData')">
                Pipes
            </div>
            <div [class.activeMenuItem]="choiceName === 'piperingBosses'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('piperingBosses','masterData')">
                Pipering Bosses
            </div>
        </div>
        <br>
        <div>
            <h5 class="nav-header pleft-20">
                <i class="fa fa-th"></i> Dictionaries</h5>
            <div [class.activeMenuItem]="choiceName === 'systems'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('systems','dictionaries')">
                Systems
            </div>
            <div [class.activeMenuItem]="choiceName === 'materials'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('materials','dictionaries')">
                Materials
            </div>
            <div [class.activeMenuItem]="choiceName === 'designBases'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('designBases','dictionaries')">
                Design bases
            </div>
            <div [class.activeMenuItem]="choiceName === 'interactionFormulas'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('interactionFormulas','dictionaries')">
                Interaction formulas
            </div>
            <div [class.activeMenuItem]="choiceName === 'corosionProtection'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('corosionProtection','dictionaries')">
                Corosion protection
            </div>
            <div [class.activeMenuItem]="choiceName === 'interactionEquations'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('interactionEquations','dictionaries')">
                Interaction equations
            </div>
            <div [class.activeMenuItem]="choiceName === 'subcomponentsForVerification'" class="justBottomBorder pleft-20 nav-element"
                (click)="setSidemenuChoice('subcomponentsForVerification','dictionaries')">
                Subcomponents for verification
            </div>
            <div [class.activeMenuItem]="choiceName === 'releases'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('releases','dictionaries')">
                Releases
            </div>
            <div [class.activeMenuItem]="choiceName === 'piperingGroups'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('piperingGroups','dictionaries')">
                Pipe-ring groups
            </div>
            <div [class.activeMenuItem]="choiceName === 'pipeFunctions'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipeFunctions','dictionaries')">
                Pipe functions
            </div>
            <div [class.activeMenuItem]="choiceName === 'pipeGroups'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipeGroups','dictionaries')">
                Pipe groups
            </div>
            <div [class.activeMenuItem]="choiceName === 'pipeMaterialGroups'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipeMaterialGroups','dictionaries')">
                Pipe material groups
            </div>
            <div [class.activeMenuItem]="choiceName === 'insulationMaterials'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('insulationMaterials','dictionaries')">
                Insulation materials
            </div>
            <div [class.activeMenuItem]="choiceName === 'pipeFasteningGroups'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipeFasteningGroups','dictionaries')">
                Pipe Fastening Groups
            </div>
            <div [class.activeMenuItem]="choiceName === 'pipeMaterialTypes'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipeMaterialTypes','dictionaries')">
                Pipe Material Types
            </div>
            <div [class.activeMenuItem]="choiceName === 'piperingFamilies'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('piperingFamilies','dictionaries')">
                Pipering families
            </div>
        </div>
        <div>
            <h5 class="nav-header pleft-20">
                <i class="fa fa-th"></i> Settings</h5>
            <div [class.activeMenuItem]="choiceName === 'pipeToPiperings'" class="justBottomBorder pleft-20 nav-element" (click)="setSidemenuChoice('pipeToPiperings','settings')">
                Pipe to Piperings
            </div>
        </div>
    </div>
</div>`,
  styles: [`#sidebar{font-size:14px;line-height:30px}#droplist{width:172px;height:22px;background-color:#2e2c2e;color:#a9a9a9;border-left:0;border-top:0;border-right:0}.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}.sidebarSystem{padding:16px 0}h5{line-height:36px}.nav-header{border-bottom:2px solid #555;text-transform:uppercase;font-size:16px}.pleft-20{padding-left:20px;padding-right:20px}.nav-element{padding-top:5px;padding-bottom:5px;border-bottom:1px solid #555}.nav-element a{color:#a9a9a9}.nav-element a:hover{text-decoration:none}.nav-element:hover{background-color:#555355;cursor:pointer}.sidemenu-panel{height:100%}.sidemenu-tabs-wrapper{overflow-y:auto;max-height:90%}`]
})
export class SideMenuComponent implements OnInit {

  public choiceName: string;

  @Input() sideBar: ConnectorGridComponent;
  constructor(private mainPageService: MainPageService) {

  }
  public ngOnInit(): void {}

  public showConnector(): void {
    this.sideBar.toggle();
  }

  public setSidemenuChoice(choiceName: string, menuTitle: string): void {
    this.choiceName = choiceName;
    this.mainPageService.sidemenuSubject.next({
    choiceName:choiceName,
    menuTitle:menuTitle
    });
    console.log(choiceName);
  }

}





